export default __webpack_public_path__ + "static/media/apk.bbf03568.svg";